import {
	GovernedChannelType,
	IGovernanceParameters,
	IGovernanceServiceResult,
} from "@ms-ofb/floodgate-shared-typings";
import { IAppGovernanceCampaignForm } from "@ms-ofb/floodgate-shared-typings/dist/src/Core/Api/IAppGovernanceProvider";

export enum GovernanceDecision {
	Approved,
	Rejected,
	Error
}

export interface IGovernanceDecision {
	governanceDecision: GovernanceDecision;
	serviceResult?: IGovernanceServiceResult;
}

export enum CampaignBusinessLevel {
	None = 0,
	Critical = 1
}

export interface IOrchestrationEngine {
	getDecision(businessLevel: CampaignBusinessLevel, governanceParams: IGovernanceParameters): Promise<IGovernanceDecision>;
	isSurveyTrackable(campaignForm: IAppGovernanceCampaignForm): boolean;
	getAvailableChannels(): GovernedChannelType[];
	mergeAndSave(): void;

	startChannelCooldown(channelType: GovernedChannelType, dateTime?: Date): void

	isChannelOpen(type: GovernedChannelType, refreshData?: boolean): boolean;
	isChannelGovernanceEnabled(governedChannelType: GovernedChannelType): boolean;

	shouldForcePermission(): boolean;
	getStateForTelemetry(): any;
}
